import React from 'react';
import { Text, View, Pressable, StyleSheet, Image, Dimensions } from 'react-native';

import { I18n, Navigation, OPPureComponent, Container } from './components';
import { COLOR, THEME, FONT } from '../constants/styles';

class Item extends OPPureComponent {
  handlePress = () => {
    const props = this.props;
    if (props.handleItemPress) {
      props.handleItemPress(props.id);
      return;
    }

    let passProps = {};
    let title = '';
    let screen = null;
    switch (props.id) {
      case 'airman':
        screen = 'CaseForm';
        title = I18n.ac_aec('employer.addNewResident');
        break;
      case 'staff':
        screen = 'CreateUser';
        title = I18n.ac('staff.addStaff');
        break;
      case 'role':
        screen = 'CreateRole';
        title = I18n.ac('staff.newRole');
        break;
      default:
        alert(`Not sure how to handle: ${props.id}`);
    }

    if (screen) {
      Navigation.showModal({
        screen,
        title,
        passProps,
      });
    }
  };

  render() {
    const props = this.props;
    return (
      <Pressable onPress={this.handlePress} key={`${props.id}`} style={styles.itemContainer}>
        <View style={styles.imageContainer}>
          <Image source={props.iconSource} style={[styles.itemIcon, props.style]} />
        </View>
        <Text style={styles.itemLabel}>{props.label}</Text>
      </Pressable>
    );
  }
}

/**
 * A utilty Modal for the generic add screen that allows adding of:
 * calendar event, checklist, immunization, deployment, etc...
 */
class AddModal extends OPPureComponent {
  render() {
    const props = this.props;
    return (
      <Container scrollView={true}>
        <View style={styles.container}>
          {!!props.staff && (
            <Item
              id="staff"
              label={I18n.ac('staff.addNewStaff')}
              iconSource={require('../../resources/icon-add-user.svg')}
              handleItemPress={props.handleItemPress}
            />
          )}
          {!!props.staff && (
            <Item
              id="role"
              label={I18n.ac('staff.addNewRole')}
              iconSource={require('../../resources/icon-add-role.svg')}
              handleItemPress={props.handleItemPress}
            />
          )}
          {!!props.airman && (
            <Item
              id="airman"
              label={I18n.ac_aec('employer.addNewResident')}
              iconSource={require('../../resources/icon-add-user.svg')}
              handleItemPress={props.handleItemPress}
            />
          )}
        </View>
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    ...THEME.container,
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingVertical: 40,
    paddingHorizontal: 20,
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
  itemContainer: {
    flex: 1,
    borderColor: COLOR.altAccent,
    borderWidth: 1,
    borderRadius: 10,
    width: 200,
    maxWidth: 200,
    minWidth: 200,
    maxHeight: 200,
    minHeight: 200,
    height: 200,
    alignContent: 'center',
    alignItems: 'center',
    marginHorizontal: 20,
    marginVertical: 20,
    paddingVertical: 30,
  },
  imageContainer: {
    width: 60,
    height: 60,
    marginTop: 10,
    marginBottom: 20,
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'center',
  },
  itemIcon: {
    width: 60,
    height: 60,
    resizeMode: 'contain',
    overflow: 'visible',
  },
  itemIconReadiness: {
    tintColor: COLOR.emphasis,
  },
  itemIconMedicalService: {
    tintColor: COLOR.emphasis,
  },
  itemIconRole: {
    tintColor: COLOR.emphasis,
    width: 120,
    height: 120,
  },
  itemLabel: {
    ...FONT.regular,
    marginBottom: 75,
    textAlign: 'center',
    marginHorizontal: 'auto',
  },
});

export default AddModal;
